export const FROM_MEDIA_PARAM = 'from';
export const FROM_MEDIA_VALUE = 'media';
export const PARENT_ID_PARAM = 'parentId';

type PathFolder = { id: string };

export const isFromMedia = (from: string | string[] | undefined) => from === FROM_MEDIA_VALUE;

export const shouldShowAssetNav = ({
  from,
  commentId,
}: {
  from?: string | string[];
  commentId?: string | string[];
}) => isFromMedia(from) || (typeof commentId === 'string' && commentId.length > 0);

export const withFromMediaQuery = (href: string, parentId?: string) => {
  const [path, search = ''] = href.split('?');
  const params = new URLSearchParams(search);

  params.set(FROM_MEDIA_PARAM, FROM_MEDIA_VALUE);

  if (parentId) {
    params.set(PARENT_ID_PARAM, parentId);
  }

  return `${path}?${params.toString()}`;
};

export const keepFromMediaQuery = (href: string) => {
  if (typeof window === 'undefined') {
    return href;
  }

  const current = new URLSearchParams(window.location.search);

  if (current.get(FROM_MEDIA_PARAM) !== FROM_MEDIA_VALUE) {
    return href;
  }

  return withFromMediaQuery(href, current.get(PARENT_ID_PARAM) ?? undefined);
};

export const withShareParentQuery = (href: string, parentId?: string) => {
  if (!parentId) {
    return href;
  }

  const [path, search = ''] = href.split('?');
  const params = new URLSearchParams(search);

  params.set(PARENT_ID_PARAM, parentId);

  return `${path}?${params.toString()}`;
};

export const getAssetParentId = ({
  queryParentId,
  file,
  stack,
}: {
  queryParentId?: string | string[];
  file?: { parent?: PathFolder; path?: PathFolder[] };
  stack?: { parent?: PathFolder; path?: PathFolder[] };
}) => {
  if (typeof queryParentId === 'string' && queryParentId) {
    return queryParentId;
  }

  return stack?.parent?.id ?? file?.parent?.id ?? stack?.path?.at(-1)?.id ?? file?.path?.at(-1)?.id;
};
